module.exports = __webpack_public_path__ + "static/media/down-arrow.4959ee5f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/megabus/down-arrow.svg
// module id = 737
// module chunks = 0